<section class="soon">
  <h1 class="soon_message">
    {{ title || "Soon.Message" | transloco }}
  </h1>
</section>
